import React, { useEffect, useState } from 'react';
import { formatDate } from "utils/chatUtils";
import moment from "moment";
import { CloseOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from "reducers/rootReducer";



const QuoteMessage: React.FC<{
    message: MessageObj;
    onCancel?: () => void;
    showCancelButton?: boolean;
}> = ({
    onCancel,
    message,
    showCancelButton
}) => {

        const { allUsers } = useSelector((state: RootState) => state.auth);
        const [username, setUsername] = useState<string | undefined>(message?.senderName);

        useEffect(() => {
            const userId: string | undefined = message?.senderName?.split("# ")[1];
            const user = allUsers?.find((obj) => obj.id === userId);
            if (user?.beamId) {
                setUsername(user?.beamId);
            } else {
                setUsername(message?.senderName);
            }
        }, [message?.senderName, allUsers]);

        return (
            <div className={`${showCancelButton ? 'r-1fdo3w0' : 'mb-2'} css-1dbjc4n r-mqqhkj r-z2wwpe r-1xhrwno r-13awgt0 r-18u37iz r-p1pxzi r-1udh08x r-bnwqim`}>
                <div className="css-1dbjc4n r-13awgt0 r-18u37iz r-1k1q3bj">
                    <div role="none" className="rxCustomScroll rxCustomScrollV">
                        <div role="none" className="scrollViewport scrollViewportV">
                            <div className="css-1dbjc4n r-z2wwpe r-p1pxzi">
                                <div role="none"
                                    className="reply-cover">
                                    <div className="css-1dbjc4n r-mqqhkj r-z2wwpe r-eqz5dr r-16y2uox r-1wbh5a2 r-p1pxzi r-1udh08x">
                                        <div className="css-1dbjc4n r-13awgt0 r-18u37iz r-y3t9qe">
                                            <div className="css-1dbjc4n r-1mlx99i r-432wen"></div>
                                            <div className="css-1dbjc4n r-16y2uox r-1wbh5a2 r-edyy15">
                                                <div role="none" aria-hidden="true" className="reply-inner">
                                                    <img className="reply-img" src="images/Reply.png" />
                                                </div>
                                                <div className="css-1dbjc4n r-13awgt0">
                                                    <div className="css-1dbjc4n r-1pz39u2 r-13awgt0 r-15d164r r-156q2ks">
                                                        <div dir="auto" className="reply-inner-box">
                                                            <div dir="auto" className="reply-inner-text">
                                                                {message?.message}</div>
                                                        </div>
                                                    </div>
                                                    <div dir="auto" className="reply-user-info-box">
                                                        {username}, {formatDate(message?.originalCreatedAt || message?.createdAt) + ' at '}
                                                        <span>
                                                            {message?.originalCreatedAt
                                                                ? moment(message?.originalCreatedAt).format("hh:mm a")
                                                                : moment(message?.createdAt).format("hh:mm a")}
                                                        </span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div role="none" className="rail railV">
                            <div role="none" className="slider"></div>
                        </div>
                    </div>
                </div>
                {showCancelButton && (<button onClick={onCancel} role="button" title="Remove quote" aria-label="Remove quote" className="btn-reply-remove">
                    <div role="none" aria-hidden="true" className="btn-reply-remove-innr">
                        <CloseOutlined />
                    </div>
                </button>)}
            </div>
        );
    }

export default QuoteMessage;
